export const ResetPasswordFromFields = [
    {
        name: "password",
        label: "Password",
        type: "password",
        placeholder: "Enter your new password",
        rules: [
            {
                required: true,
                message: 'Please input your password!',
            },
            {
                min: 8,
                message: 'Password must be at least 8 characters long!',
            },
        ],
    },
    {
        name: "confirmPassword",
        label: "Confirm Password",
        type: "password",
        dependencies: ["password"],
        placeholder: "Confirm your password",
        rules: [
            {
                required: true,
                message: 'Please confirm your password!',
            },
            ({ getFieldValue }) => ({
                validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                    }
                    return Promise.reject("The two passwords that you entered do not match.");
                },
            }),
        ],
    },
    {
        name: "submit",
        label: "Reset Password",
        type: "submit",
        htmlType: "submit",
        className: "btn-primary mt-4",
        buttonType: "primary",
        block: true,
    },
]
